module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/022-4f586f2b8e214c46c88e77b5e9fb96ce.jpg";